/**
 * @package  	Cavalree_Infatree_Theme
 * @copyright	Copyright (c) 2021 Infantree (https://infantree.com/)
 * @version  	1.0.0
 *
 */

if (typeof $ === "undefined") {
    var $ = jQuery;
}

/*****************************
 * Vanilla JS functions
 *****************************/
// END Vanilla JS

/*****************************
 * jQuery Ready
 *****************************/
$(document).ready(function () {
    console.log('Hello child theme');
});
